import { useCachedGet } from "@/lib/cache";
import { useAuth } from "@/lib/auth";

export const ADMIN_ROLES = new Set(["tenant_admin", "platform_owner", "owner", "admin"]);
export const isLicenseAdmin = (user) => !!user && ADMIN_ROLES.has(user.role);
export const fmtDate = (iso) => (iso ? new Date(iso).toLocaleDateString(undefined, { day: "numeric", month: "short", year: "numeric" }) : "—");
export const STATE_META = {
  ok: { label: "Healthy", cls: "bg-emerald-50 text-emerald-700 border-emerald-200", bar: "bg-indigo-500" },
  warning: { label: "Over 80% used", cls: "bg-amber-50 text-amber-700 border-amber-200", bar: "bg-amber-500" },
  grace: { label: "Using grace", cls: "bg-orange-50 text-orange-700 border-orange-200", bar: "bg-orange-500" },
  blocked: { label: "Invites paused", cls: "bg-rose-50 text-rose-700 border-rose-200", bar: "bg-rose-500" },
  trial_ended: { label: "Trial ended", cls: "bg-rose-50 text-rose-700 border-rose-200", bar: "bg-rose-500" },
};

// Lightweight usage summary for admins (null for others).
export function useLicenseSummary() {
  const { user } = useAuth();
  const admin = isLicenseAdmin(user);
  const [data] = useCachedGet(admin ? "/license/summary" : null);
  return admin ? data : null;
}
